"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore-next-line importsNotUsedAsValues
require("react");
// Utility function to merge multiple refs
const mergeRefs = (refs) => {
    return (value) => {
        refs.forEach(ref => {
            if (typeof ref === 'function') {
                ref(value);
            }
            else if (ref) {
                ref.current = value;
            }
        });
    };
};
exports.default = mergeRefs;
